import moment from 'moment'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { DAY_MONTH_NAME_SHORT, DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LesaPurchaseSummaryOrderItemStatus from './LesaPurchaseSummaryOrderItemStatus'

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(${rem(16)}, max-content) 1fr;
  grid-template-rows: auto;
  grid-row-gap: ${rem(4)};
`

const StyledBookingNumber = styled.div`
  grid-column: 1 / span 2;
`

interface Props {
  startDate?: string | null
  endDate?: string | null
  duration?: string | number
  bookingNumber?: string
  status?: App.OrderItemStatus
  showReservationDates?: boolean
}

export default function LesaPurchaseSummaryItineraryDates(props: Props) {
  const intl = useIntl()
  const { showReservationDates, status, startDate, endDate, duration, bookingNumber } = props

  const formattedStartDate = startDate ? moment(startDate).format(DAY_MONTH_NAME_SHORT) : ''
  const formattedEndDate = endDate ? moment(endDate).format(DMY_CASUAL_SHORT_FORMAT) : ''
  const dateRangeLabel = duration ? intl.formatMessage(
    {
      id: 'mVTm_mUGPqNVAkBp_3g3',
      defaultMessage: '{startDate} - {endDate} ({duration})',
      description: 'Date range with duration in parentheses, e.g. 5 Jan - 10 Jan 2025 (5 nights)',
    },
    {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      duration: String(duration),
    },
  ) : intl.formatMessage(
    {
      id: 'sMi66sQ5IIFokb0QiMxq',
      defaultMessage: '{startDate} - {endDate}',
      description: 'Date range for the purchase summary itinerary dates',
    },
    {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    },
  )

  return (
    <Container>
      {!startDate && <LesaPurchaseSummaryOrderItemStatus status={status} />}
      {showReservationDates && startDate && <BodyTextBlock variant="small" colour="neutral-two">
        {dateRangeLabel}
      </BodyTextBlock>}
      {bookingNumber && <StyledBookingNumber>
        <BodyTextBlock variant="small" colour="neutral-two">
          <FormattedMessage
            id="-oAQT_vxsmof4SAnZZ2S"
            defaultMessage="<strong>Booking ID:</strong> {bookingNumber}"
            description="Label and value display for the booking identifier in the order confirmation details"
            values={{
              bookingNumber,
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </BodyTextBlock>
      </StyledBookingNumber>}
    </Container>
  )
}
